import React from 'react'
import MyCourses from '../../features/student/MyCourses'

const MyCoursesPage = () => {
  return <MyCourses/>
}

export default MyCoursesPage